<script>
    import {attributeLoad, attributeSave} from "../lib/requests";
    import app_alert from "../stores/alerts";
    import success from '../stores/success';
    import Modal from '../components/Modal.svelte';
    import AttributeData from "./AttributeData.svelte";

    export let attributeId = null;
    export let categories = [];
    export let closeCallback;

    const word_translations = {
        'Μοντέλο': 'Model',
        'Μάρκα': 'Brand',
        'Κατηγορία': 'Category',
        'Κρεβάτια': 'Beds',
        'Άλλα Χαρακτηριστικά': 'Other Features',
        'Χαρακτηριστικά': 'Features',
        'Χρώμα': 'Color',
    }

    const translations = {
        'Άλλο': 'Other',
    }

    let attribute = null;
    let loading = false;
    let hasData = false;

    const latinOnly = (value) => {
        const hasGreek = /[Α-Ωα-ωΆ-Ώά-ώ]/.test(value);
        return !hasGreek;
    }

    const translate = (value) => {
        Object.keys(word_translations).map(key => {
            value = value.replaceAll(key, word_translations[key]);
        });

        Object.keys(translations).map(key => {
            if (value === key) {
                value = translations[key];
            }
        });

        return value;
    }

    const load = async () => {
        loading = true;

        const [err, res] = await attributeLoad(attributeId);

        if (err) {
            alert('error ' + err)
            return;
        }

        attribute = res;
        if (attribute.name_en == null) {
            attribute.name_en = '';
        }
        let trans = '';
        if (attribute.name_en === '') {
            trans = translate(attribute.name_el);
            console.log(trans);
            if (latinOnly(trans)) {
                attribute.name_en = trans;
            }
        }

        if (attribute.data && attribute.data.length > 0) {
            attribute.data.map((item) => {
                if (item.en === '') {
                    trans = translate(item.el);
                    if (latinOnly(trans)) {
                        item.en = trans;
                    }
                }
            });
        }

        hasData = attribute.data != null && attribute.data.length > 0;
        loading = false;
    }

    const save = async () => {
        if (attribute.name_el.trim().length == 0 || attribute.name_en.trim().length == 0) {
            app_alert.show('error', "Πληκτρολογήστε το όνομα του χαρακτηριστικού και στις 2 γλώσσες!");
            return;
        }

        if (attribute.type === 'input') {
            attribute.data = [];
        }

        const [err, res] = await attributeSave(attribute);

        if (err) {
            alert('error ' + err);
            return;
        }

        success.show("Το χαρακτηριστικό ενημερώθηκε.");

        attribute = res;
        close(attribute);
    }

    const close = param => {
        attribute = null;

        if (param instanceof Event) {
            closeCallback();
            return;
        }

        setTimeout(() => {
            closeCallback(param);
        }, 200);
    }

    load();
</script>

{#if attribute}
    <Modal modalLg={hasData} title="Χαρακτηριστικό" on:close="{ close }">
        <div slot="body">
            <div class="row">
                <div class:col-md-6={hasData} class:col-md-12={!hasData}>
                    <legend>Στοιχεία</legend>
                    <div class="form-group">
                        <label>Όνομα - ελληνικά</label>
                        <input type="text" class="form-control" bind:value={attribute.name_el}>
                    </div>
                    <div class="form-group">
                        <label>Όνομα - αγγλικά</label>
                        <input type="text" class="form-control" bind:value={attribute.name_en}>
                    </div>
                    <div class="form-group">
                        <label>Τύπος</label>
                        <select class="form-control" bind:value={attribute.type} disabled>
                            <option value="input">Input</option>
                            <option value="number">Number</option>
                            <option value="date">Date</option>
                            <option value="checkbox">Checkbox</option>
                            <option value="radio">Radio</option>
                            <option value="select">Select</option>
                        </select>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Tip - ελληνικά</label>
                        <input type="text" class="form-control" bind:value={attribute.placeholder.el}>
                    </div>
                    <div class="form-group">
                        <label>Tip - αγγλικά</label>
                        <input type="text" class="form-control" bind:value={attribute.placeholder.en}>
                    </div>
                    <hr>
                    <div class="form-group">
                        <label>Μήνυμα - ελληνικά</label>
                        <textarea class="form-control" bind:value={attribute.prompt.el}></textarea>
                    </div>
                    <div class="form-group">
                        <label>Μήνυμα - αγγλικά</label>
                        <textarea class="form-control" bind:value={attribute.prompt.en}></textarea>
                    </div>
                </div>
                {#if hasData}
                    <div class="col-md-6">
                        <legend>Τιμές</legend>
                        <AttributeData bind:data={attribute.data}/>
                    </div>
                {/if}
            </div>
            <hr>
            <div class="text-right">
                <div class="btn btn-link me-4" on:click="{ () => close() }">Κλείσιμο</div>
                <button class="btn btn-primary px-4" on:click="{ save }">Ενημέρωση</button>
            </div>
        </div>
    </Modal>
{/if}